<div class="notification" id="targetSection">
  <div>
    @if (inboxStatus) {
      <ng-lottie
        [options]="inboxOptions"
        class="inbox-animation"
        (click)="onClick('inbox_icon'); showInbox();"
        (animationCreated)="updateAnimationStatus('inbox_icon', inboxDuration);"
      ></ng-lottie>
    }
  </div>
  <app-inbox-title-nudge></app-inbox-title-nudge>
  <ion-icon name="mail-outline" class="notify-icon" (click)="showInbox()"></ion-icon>
</div>
